import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const uploadAreaStyles = makeStyles((theme: Theme) =>
    createStyles({
        dropArea: {
            margin: "50px",
        },
        drag: {
            border: "2px dashed #454545",
            borderRadius: "4px",
            padding: "90px 10px 90px 10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        dragged: {
            borderRadius: "4px",
            padding: "97px 10px 96px 10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(223, 234, 255, 1)",
            border: "2px dashed rgba(223, 234, 255, 1)",
        },
        fileInput: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "15px",
        },
        fileLabel: {
            backgroundColor: "#270ADC",
            padding: "8px 25px 8px 25px",
            color: "white",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "16px",
        },
        resultDocumentsList: {
            marginTop: "20px",
        },
        modal: { display: "flex", alignItems: "center", justifyContent: "center" },
        main: {
            padding: "30px",
            minWidth: "40%",
        },
        closeIcon: {
            float: "right",
            cursor: "pointer",
        },
        modalTitle: {
            marginTop: "20px",
        },
        modalSubtitle: { lineHeight: "120%", marginTop: "10px" },
    })
);
